export default __webpack_public_path__ + "static/media/logo.904ac8fd.png";